import React from 'react';
import { fromUnixTime, format } from 'date-fns';

import {
    timezones,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';


export {
    DatetimePicker, TimezoneContext, TimePicker,
};

/* FRONTEND_START_MARKER */
const TimezoneContext = React.createContext();

const TimePicker = ({
    time, handleChange, edit, className, disabled,
}) => {
    const [inputTime, setInputTime] = React.useState();
    const [displayTime, setDisplayTime] = React.useState(Number.isNaN(time) ? 0 : time);
    // ensure time is valid number
    React.useEffect(() => {
        if (Number.isNaN(time)) {
            setDisplayTime(0);
        } else {
            setDisplayTime(time);
        }
    }, [time]);

    const onChange = (e) => {
        const value = e.target.value;
        if (value === '') return;
        setInputTime(value);
        const parts = value.split(':');
        const newValue = ((parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10)) * 60).toString();
        handleChange(newValue);
    };

    React.useEffect(() => {
        setInputTime(format(fromUnixTime(displayTime + new Date().getTimezoneOffset() * 60), 'HH:mm'));
    }, [displayTime]);

    if (!edit) {
        return (
            <div>{format(fromUnixTime(displayTime + new Date().getTimezoneOffset() * 60), 'hh:mm aa')}</div>
        );
    }

    return (
        <input
            className={`form-control ${className || ''}`}
            type="time"
            value={inputTime}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

const DatetimePicker = ({
    time, handleChange, edit, className, disabled,
}) => {
    const timezone = React.useContext(TimezoneContext);
    const minutesOffset = React.useMemo(() => {
        if (timezone === undefined) return new Date().getTimezoneOffset() * -1;
        return timezones.find(el => el.value === timezone.toString()).minutesOffset;
    }, [timezone]);

    const [displayDatetime, setDisplayDatetime] = React.useState(Number.isNaN(time) ? 0 : time);
    // ensure datetime is valid
    React.useEffect(() => {
        if (Number.isNaN(time)) {
            setDisplayDatetime(0);
        } else {
            setDisplayDatetime(time);
        }
    }, [time]);

    const [datetime, setDatetime] = React.useState(
        {
            date: format(fromUnixTime((displayDatetime + minutesOffset * 60) + new Date().getTimezoneOffset() * 60), 'yyyy-MM-dd'),
            time: format(fromUnixTime((displayDatetime + minutesOffset * 60) + new Date().getTimezoneOffset() * 60), 'HH:mm'),
        },
    );

    React.useEffect(() => {
        if (!edit) return;
        const updateValue = Date.parse(`${datetime.date}T${datetime.time}`)
        - (new Date().getTimezoneOffset() + minutesOffset) * 60 * 1000;
        handleChange(updateValue / 1000);
    }, []);

    React.useEffect(() => {
        // if (!disabled) return;
        setDatetime({
            date: format(fromUnixTime((displayDatetime + minutesOffset * 60) + new Date().getTimezoneOffset() * 60), 'yyyy-MM-dd'),
            time: format(fromUnixTime((displayDatetime + minutesOffset * 60) + new Date().getTimezoneOffset() * 60), 'HH:mm'),
        });
    }, [displayDatetime]);

    const onChange = (e, type) => {
        const value = e.target.value;
        if (value === '') return;
        const newDatetime = { ...datetime };
        newDatetime[type] = value;
        setDatetime(newDatetime);
        const updateValue = Date.parse(`${newDatetime.date}T${newDatetime.time}`)
            - (new Date().getTimezoneOffset() + minutesOffset) * 60 * 1000;
        handleChange(updateValue / 1000);
    };

    return (
        <div className={`d-flex flex-row ${className || ''}`} data-timestamp={time}>
            <input className={!edit || disabled ? 'dashboard-disabled-date-input' : 'form-control'} type="date" value={datetime.date} onChange={e => onChange(e, 'date')} disabled={!edit || disabled} />
            <input className={!edit || disabled ? 'dashboard-disabled-date-input' : 'form-control'} type="time" value={datetime.time} onChange={e => onChange(e, 'time')} disabled={!edit || disabled} />
        </div>
    );
};
